'use client';

import { __awaiter, __generator, __assign } from '../../_virtual/_tslib.js';
import React__default, { useRef, useState, useEffect, useImperativeHandle } from 'react';
import { Working, Contact, Required } from '../index.css.js';
import { useResumeModal } from '../context/useResumeModal.js';
import Input from '../../Input/index.js';
import CompanyIndustry from '../../CompanyIndustry/index.js';
import MultipleRadio from '../../MultipleRadio/index.js';
import InputYOE from '../../InputYOE/index.js';
import { DEFAULT_MAX_LENGTH_JOB_TITLE, INTERNSHIP_ID, FRESHER_ID, MIN_YEAR_OF_EXPERIENCE, MAX_YEAR_OF_EXPERIENCE, LITMIT_SELECTION, MIN_SALARY, MAX_SALARY, DEFAULT_SUCCESS_CODE } from '../constants.js';
import Form from '../../Form/index.js';
import { rules } from '../utils/index.js';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import { autoCompleteJobTitle, getJobLevelList, apiPostResume } from '../apiServices.js';
import { ELanguage } from '../../Utils/constants.js';
import MultipleSelect from '../../MultipleSelect/index.js';
import { ETab } from '../type.js';
import { educationListVi, educationListEn } from '../translations.js';
import { isDesktop } from '../../Utils/helpers.js';
import { showToast, TOAST_TYPE_ERROR } from '../../Toast/index.js';
import JobFunction from '../../JobFunction/index.js';

var WorkingReference = function (_a, ref) {
    var _b = _a.isReloadOnClose, isReloadOnClose = _b === void 0 ? true : _b, baseApiUrl = _a.baseApiUrl, apiAutoCompleteJobTitle = _a.apiAutoCompleteJobTitle, apiGetJobLevelList = _a.apiGetJobLevelList, accessToken = _a.accessToken, jobLocationOptions = _a.jobLocationOptions, formData = _a.formData, jobIndustryOptions = _a.jobIndustryOptions, checkBeforeSubmitForm = _a.checkBeforeSubmitForm, handleClosePopup = _a.handleClosePopup, apiUpdateResume = _a.apiUpdateResume, logoutUrl = _a.logoutUrl, resumeId = _a.resumeId, setWorkingPreferenceData = _a.setWorkingPreferenceData, _c = _a.jobFunctionOptions, jobFunctionOptions = _c === void 0 ? {
        parent: [],
        child: {}
    } : _c, checkDoneStep = _a.checkDoneStep;
    var _d = useResumeModal(), t = _d.t, lang = _d.lang, step = _d.step, setShowLoading = _d.setShowLoading;
    var isMobile = !isDesktop();
    var formRef = useRef(null);
    var _e = useState(), jobsTitleRecommend = _e[0], setJobsTitleRecommend = _e[1];
    var _f = useState([]), jobsLevel = _f[0], setJobsLevel = _f[1];
    var eventTimeout;
    var currentValue;
    var handleDebounceChangeEvent = function (value) {
        if (eventTimeout) {
            clearTimeout(eventTimeout);
            eventTimeout = null;
        }
        currentValue = value;
        var getRecommendJobTitle = function () { return __awaiter(void 0, void 0, void 0, function () {
            var autoCompleteResponse, recommendList, mappedList_1, error_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (currentValue !== value) {
                            setJobsTitleRecommend(undefined);
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, autoCompleteJobTitle("".concat(baseApiUrl).concat(apiAutoCompleteJobTitle), value, accessToken)];
                    case 2:
                        autoCompleteResponse = _d.sent();
                        recommendList = (_c = (_b = (_a = autoCompleteResponse === null || autoCompleteResponse === void 0 ? void 0 : autoCompleteResponse.data) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.suggestJobTitle) !== null && _c !== void 0 ? _c : [];
                        if (recommendList.length > 0) {
                            mappedList_1 = [];
                            recommendList.map(function (item, index) {
                                mappedList_1.push({
                                    id: index,
                                    name: item
                                });
                            });
                            setJobsTitleRecommend(mappedList_1);
                            return [2 /*return*/];
                        }
                        setJobsTitleRecommend([]);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _d.sent();
                        setJobsTitleRecommend([]);
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        eventTimeout = setTimeout(getRecommendJobTitle, 500);
    };
    var doGetJobLevelList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var getJobLevelListRespone, returnJobLevelList_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (jobsLevel.length > 0) {
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, getJobLevelList(apiGetJobLevelList)];
                case 1:
                    getJobLevelListRespone = _a.sent();
                    if (getJobLevelListRespone.data !== undefined &&
                        getJobLevelListRespone.data.relationships !== undefined &&
                        getJobLevelListRespone.data.relationships.data !== undefined) {
                        returnJobLevelList_1 = [];
                        getJobLevelListRespone.data.relationships.data.map(function (item) {
                            returnJobLevelList_1.push({
                                id: item.id,
                                name: lang === ELanguage.EN ? item.attributes.nameEn : item.attributes.nameVi
                            });
                        });
                        setJobsLevel(returnJobLevelList_1);
                    }
                    return [2 /*return*/, false];
            }
        });
    }); };
    var getOptions = function (values) {
        var _a;
        return ((_a = values === null || values === void 0 ? void 0 : values.map(function (e) {
            var _a;
            return {
                id: parseInt(String(e.id)),
                name: (_a = e === null || e === void 0 ? void 0 : e.name) !== null && _a !== void 0 ? _a : ''
            };
        })) !== null && _a !== void 0 ? _a : []);
    };
    useEffect(function () {
        if (step === ETab.WORKING_PREFERENCE) {
            doGetJobLevelList();
        }
    }, [step]);
    var handleOnClickSaveProfile = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isUpdateSuccess, params, postResumeResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setShowLoading(true);
                    _a = checkBeforeSubmitForm;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, checkBeforeSubmitForm(values)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    /*
                     * Check before submit data
                     * */
                    if (_a) {
                        // Hide loading overlay
                        handleClosePopup();
                        checkDoneStep &&
                            checkDoneStep(3, {
                                jobTitle: values.jobTitle
                            });
                        return [2 /*return*/];
                    }
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    isUpdateSuccess = false;
                    params = {
                        url: "".concat(baseApiUrl).concat(apiUpdateResume),
                        accessToken: accessToken || '',
                        data: __assign(__assign(__assign({}, values), { locations: values.locations.map(function (location) { return ({ cityId: location }); }), yearsExperience: values.yearsExperience ? Number(values.yearsExperience) : 0, salary: values.salary ? Number(values.salary) : 0 }), (!resumeId ? null : { resumeId: resumeId }))
                    };
                    return [4 /*yield*/, apiPostResume(params)];
                case 4:
                    postResumeResponse = _b.sent();
                    isUpdateSuccess = postResumeResponse.meta.code === DEFAULT_SUCCESS_CODE;
                    // Check Error when call API
                    if (isUpdateSuccess) {
                        handleClosePopup();
                        checkDoneStep &&
                            checkDoneStep(3, {
                                jobTitle: values.jobTitle
                            });
                        // Do reload when save success!
                        isReloadOnClose && window.location.reload();
                    }
                    else {
                        showToast(t('Phiên Sử Dụng Hết Hạn'), t('Bạn vui lòng đăng nhập lại'), TOAST_TYPE_ERROR);
                        setTimeout(function () {
                            window.location.href = logoutUrl;
                        }, 3000);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    _b.sent();
                    showToast(t('Lỗi '), t('Không thể cập nhật thông tin!'), TOAST_TYPE_ERROR);
                    return [3 /*break*/, 6];
                case 6:
                    setShowLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };
    var syncData = function (field, value) {
        setWorkingPreferenceData(function (state) {
            var _a;
            return (__assign(__assign({}, state), (_a = {}, _a[field] = value, _a)));
        });
    };
    useImperativeHandle(ref, function () {
        return {
            onSubmit: onSubmit
        };
    }, []);
    return (React__default.createElement(Working.Section, null,
        React__default.createElement(Contact.SectionWrapper, { isMobile: isMobile },
            React__default.createElement(Working.Title, null, t('Thông tin được tự động điền cho bạn nếu có thể.')),
            React__default.createElement(Form, { ref: formRef, initialValues: formData, requestScrollToFirstErrorElement: true, onSubmit: function (values) { return handleOnClickSaveProfile(values); } },
                React__default.createElement("button", { type: 'submit', hidden: true }, "button"),
                React__default.createElement(Row, { gutter: [24, 16] },
                    React__default.createElement(Form.Item, { name: 'jobTitle', rules: rules({
                            types: ['required', 'no-special-chars-for-job-title'],
                            t: t
                        }) }, function (field) { return (React__default.createElement(Col, { xs: 24 },
                        React__default.createElement(Form.Label, null,
                            " ",
                            t('Chức danh hiện tại')),
                        React__default.createElement(Input, { type: 'text', placeholder: t('Nhập chức danh'), value: field.value, onChange: function (value) {
                                field.onChange(value);
                                handleDebounceChangeEvent(value);
                                syncData('jobTitle', value);
                            }, listRecommend: jobsTitleRecommend, searchNotFound: t('Không có kết quả'), onClickSuggestionItem: function (item) {
                                if ((item === null || item === void 0 ? void 0 : item.id) === -1)
                                    return;
                                field.onChange(item.name);
                                syncData('jobTitle', item.name);
                            }, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: DEFAULT_MAX_LENGTH_JOB_TITLE, autoFocus: true }),
                        React__default.createElement(Form.Error, null))); }),
                    React__default.createElement(Form.Item, { name: 'jobLevelId', rules: rules({
                            types: ['required'],
                            t: t
                        }) }, function (field) {
                        return (React__default.createElement(Col, { md: 12, xs: 24 },
                            React__default.createElement(Form.Label, null,
                                " ",
                                t('Cấp bậc hiện tại')),
                            React__default.createElement(MultipleRadio, { options: jobsLevel, name: 'jobLevelId', placeholder: t('Vui lòng chọn ...'), value: field.value, onBlur: field.onBlur, onChange: function (value) {
                                    field.onChange(value.value);
                                    syncData('jobLevelId', value.value);
                                }, hasError: field.isError, dropdown: {
                                    maxHeight: '250px',
                                    isSearchable: true,
                                    emptyText: t('Không Có Kết Quả Nào'),
                                    searchBoxPlaceholder: t('Tìm'),
                                    floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true,
                                        useWindowAsFlippingContainer: true
                                    }
                                } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'yearsExperience', watch: ['jobLevelId'], rules: rules({
                            types: ['custom'],
                            custom: {
                                validator: function (value, watch) {
                                    var isHightLevel = ![INTERNSHIP_ID, FRESHER_ID].includes(watch.jobLevelId);
                                    var isValid = !isHightLevel || (value && isHightLevel);
                                    return isValid;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            },
                            t: t
                        }) }, function (field) {
                        var _a, _b;
                        var isHightLevel = ![INTERNSHIP_ID, FRESHER_ID].includes((_a = field.watch) === null || _a === void 0 ? void 0 : _a.jobLevelId);
                        return (React__default.createElement(Col, { md: 12, xs: 24 },
                            React__default.createElement(Form.Label, { require: isHightLevel }, t('Số năm kinh nghiệm')),
                            React__default.createElement(InputYOE, { onChange: function (value) {
                                    field.onChange(value);
                                    syncData('yearsExperience', value);
                                }, onBlur: function () { return field.onBlur(); }, postfixText: t('Năm'), defaultValue: (_b = field.value) !== null && _b !== void 0 ? _b : 0, isError: !isHightLevel ? false : field.isError, options: {
                                    min: MIN_YEAR_OF_EXPERIENCE,
                                    max: MAX_YEAR_OF_EXPERIENCE,
                                    fontSizeErrorText: 14
                                } }),
                            React__default.createElement(Form.Error, { disable: !isHightLevel })));
                    }),
                    React__default.createElement(Form.Item, { name: 'jobFunction', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (React__default.createElement(Col, null,
                            React__default.createElement(Form.Label, { require: true }, t('Ngành nghề mong muốn')),
                            React__default.createElement(JobFunction, { isMobile: isMobile, data: jobFunctionOptions, value: field.value, langCode: lang, onChange: function (value) {
                                    field.onChange(value);
                                    syncData('jobFunction', value);
                                }, dropdownStyleOptions: {
                                    width: '100%'
                                }, onBlur: field.onBlur, hasError: field.isError, isSingleSelect: true, displayAsPopup: true, isFlex: true, textOptions: {
                                    placeholder: t('Chọn ngành nghề')
                                }, selectOptions: {
                                    isSingleSelect: true
                                }, floatingConfig: {
                                    position: 'fixed',
                                    enablePortal: true,
                                    useWindowAsFlippingContainer: true
                                }, scrollLockMode: 'soft' }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'companyIndustries', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (React__default.createElement(Col, null,
                            React__default.createElement(Form.Label, { require: true },
                                " ",
                                t('Lĩnh vực mong muốn')),
                            React__default.createElement(CompanyIndustry, { type: 'multiple-select', options: jobIndustryOptions !== null && jobIndustryOptions !== void 0 ? jobIndustryOptions : [], value: field.value, onChange: function (value) {
                                    field.onChange(value);
                                    syncData('companyIndustries', value);
                                }, onBlur: field.onBlur, hasError: field.isError, langCode: lang, isMobile: false, floatingConfig: {
                                    position: 'fixed',
                                    enablePortal: true,
                                    useWindowAsFlippingContainer: true
                                }, optionsStyle: { maxHeight: '150px' } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'locations', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!value || (value === null || value === void 0 ? void 0 : value.length) < 1) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (React__default.createElement(Col, null,
                            React__default.createElement(Form.Label, { require: true },
                                " ",
                                t('Nơi làm việc mong muốn')),
                            React__default.createElement(MultipleSelect, { name: 'locations', options: getOptions(jobLocationOptions), defaultSelect: field.value, onChange: function (e) {
                                    field.onChange(e.value);
                                    syncData('locations', e.value);
                                }, onBlur: field.onBlur, selectPlaceholder: t('Chọn địa điểm'), optionsStyle: { maxHeight: '200px' }, dropdownStyle: { width: '100%' }, limitText: t('Bạn chỉ có thể chọn tối đa 3 địa điểm'), limit: LITMIT_SELECTION, isMobile: false, langCode: lang, hasError: field.isError, sortEnable: true, floatingConfig: {
                                    position: 'fixed',
                                    enablePortal: true,
                                    useWindowAsFlippingContainer: true
                                } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'highestDegreeId', rules: rules({
                            types: ['required'],
                            t: t
                        }) }, function (field) {
                        return (React__default.createElement(Col, { md: 12, xs: 24 },
                            React__default.createElement(Form.Label, null,
                                " ",
                                t('Trình độ học vấn')),
                            React__default.createElement(MultipleRadio, { options: (lang === ELanguage.VI ? educationListVi : educationListEn).filter(function (item) { return item.id !== 0; }), name: 'highestDegree', placeholder: t('Vui lòng chọn...'), value: field.value, onChange: function (value) {
                                    syncData('highestDegreeId', value.value);
                                    field.onChange(value.value);
                                }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                                    maxHeight: '250px',
                                    isSearchable: true,
                                    emptyText: t('Không Có Kết Quả Nào'),
                                    searchBoxPlaceholder: t('Tìm'),
                                    floatingConfig: {
                                        position: 'fixed',
                                        enablePortal: true,
                                        useWindowAsFlippingContainer: true
                                    }
                                } }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Form.Item, { name: 'salary', rules: [
                            {
                                type: 'custom',
                                validator: function (value) {
                                    if (!parseInt(value)) {
                                        return false;
                                    }
                                    return true;
                                },
                                msg: t('Vui lòng nhập thông tin.')
                            }
                        ] }, function (field) {
                        return (React__default.createElement(Col, { md: 12, xs: 24 },
                            React__default.createElement(Form.Label, { require: true }, t('Mức lương mong muốn')),
                            React__default.createElement(InputYOE, { postfixText: t('USD/tháng'), defaultValue: Number(field.value) > 0 ? field.value : '', isError: field.isError, options: {
                                    min: MIN_SALARY,
                                    max: MAX_SALARY,
                                    canBeEmpty: true,
                                    fontSizeErrorText: 14
                                }, typeInput: 'text', onChange: function (value) {
                                    syncData('salary', value);
                                    field.onChange(value);
                                }, onBlur: field.onBlur }),
                            React__default.createElement(Form.Error, null)));
                    }),
                    React__default.createElement(Col, null,
                        React__default.createElement(Required, null,
                            React__default.createElement("span", null, "*"),
                            " ",
                            t('Thông tin bắt buộc'))))))));
};
var WorkingReference$1 = React__default.forwardRef(WorkingReference);

export { WorkingReference$1 as default };
//# sourceMappingURL=WorkingReference.js.map
